module.exports = __webpack_public_path__ + "static/kulitan-ee9d56d793b9777095a25b86a1019cae.jpg";